import React, { useState } from "react"
import { Checkbox } from "flowbite-react";
import { useContrato } from "../../../../../../../context/ContratoContext";
// import { Total } from "../../../../../../../services/data/dummyContratos";
// import { useModal } from "../../../../../../../hooks/ModalContext";
import { TabelaParcelasData } from "../parcelas";

import { useDividas } from "../../../../../../../context/DividasContext";
import { differenceInDays } from "date-fns";
import { BiMinusCircle, BiPlusCircle } from "react-icons/bi";

export const Contrato = () => {
  const {
    // contratoParaNegociar,
    // parcelaParaNegociar,
    showParcelas,
    showParcelasContrato,
    // parcelasParaNegociar,
    // contratos,
    // isJuncao,
    contratosData,
    getConsultaParamentros,
    consultParamentros,
    getDividasWS,
    dividaData
  } = useContrato()
  const { selectedCredor, devedor } = useDividas()
  // const { setModal } = useModal();
  const [show, setShow] = useState(false)

  // function contratoIsChecked(contrato: ContratoProps) {
  //   const parcsChecked = parcelasParaNegociar.filter(
  //     (parc) => parc.contrato === contrato.contrato
  //   );
  //   return parcsChecked.length === contrato.parcelas.length;
  // }
  // console.log(contratosData.contratos)

  async function checkedContrato(cpf_cnpj: string, codcredor: string, contrato: string, isCheck?: boolean) {
    if (isCheck && show) {
      setShow(true)
      return
    }
    if (dividaData?.length <= 0) {
      await getDividasWS({ codcredor, contrato, cpf_cnpj, url: selectedCredor.url_ws })
      await getConsultaParamentros({ codcredor, contrato, cpf_cnpj, formapagamento: '1', url: selectedCredor.url_ws })
    }
    setShow(!show)
  }

  function formatDate(date: string) {
    const [dia, mes, ano] = date.split('/')
    return `${mes}/${dia}/${ano}`
  }
  //  ${c.permitedivida ? " bg-green-500" : " bg-red-500"
  return (<>
    {
      contratosData?.contratos?.length > 0 && contratosData.contratos.map(c => (
        <div key={c.numcontrato} className={`mb-4 rounded-md bg-white `}>
          <div className="flex w-full rounded-md border border-gray-400 pr-2">
            <div
              className={`mr-2 w-2 rounded-l-md 
             
                } `}
            ></div>
            <div className="w-full py-2">
              <div>
                <div className="my-2 flex items-center justify-between text-sm">
                  <div className="flex items-center ">
                    <Checkbox
                      color="green"
                      className="mr-2 bg-primary"
                      onChange={() => {
                        checkedContrato(devedor.cpf_cnpj, c.codcredor, c.numcontrato, true)
                        showParcelasContrato(c.numcontrato);
                      }}
                    />
                    <strong className="font-medium text-xs text-gray-600">
                      Contrato: {c.numcontrato}
                    </strong>
                  </div>

                  <p className="font-medium text-xs text-gray-600">
                    Dias em atraso:
                    <strong className="ml-1">
                      {differenceInDays(new Date(), new Date(formatDate(c.vencimento)))}
                    </strong>
                  </p>


                  <button
                    className="text-lg font-bold"
                    onClick={() => {
                      if (!show) {
                        setShow(true)
                      }
                      checkedContrato(devedor.cpf_cnpj, c.codcredor, c.numcontrato)
                      showParcelasContrato(c.numcontrato);
                    }}
                  >
                    {
                      show ?
                        <BiMinusCircle size={24} className="fill-primary" /> : <BiPlusCircle size={24} className="fill-primary" />
                    }
                  </button>
                </div>
              </div>

              <div
                className={`${!show && dividaData && "hidden"
                  } `}
              >
                <>

                  {
                    dividaData && dividaData.length > 0 && <TabelaParcelasData prestacoes={dividaData} />
                  }


                </>

              </div>
            </div>
          </div>
        </div>
      )


      )
    }
  </>)
}